var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 17C2.55936 9.36818 8.33837 3.25864 15.8124 1.17953C16.4397 1.00502 16.7534 0.917756 16.9224 1.10472C17.0914 1.29167 16.9669 1.60083 16.7179 2.21912L15 6M25 1C32.6318 2.55936 38.7414 8.33837 40.8205 15.8124C40.995 16.4397 41.0822 16.7534 40.8953 16.9224C40.7083 17.0914 40.3992 16.9669 39.7809 16.7179L36 15M41 25C39.4406 32.6318 33.6616 38.7414 26.1876 40.8205C25.5603 40.995 25.2466 41.0822 25.0776 40.8953C24.9086 40.7083 25.0331 40.3992 25.2821 39.7809L27 36M17 41C9.36818 39.4406 3.25864 33.6616 1.17953 26.1876C1.00502 25.5603 0.917756 25.2466 1.10472 25.0776C1.29167 24.9086 1.60083 25.0331 2.21912 25.2821L6 27",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2258 20.3294L21.224 11.3465C21.7713 10.644 22.7972 11.0812 22.7972 12.0171V18.9699C22.7972 19.5305 23.1995 19.985 23.6958 19.985H27.0996C27.8729 19.985 28.2851 21.0149 27.7742 21.6706L20.776 30.6535C20.2287 31.356 19.2028 30.9188 19.2028 29.9829V23.0301C19.2028 22.4695 18.8005 22.015 18.3042 22.015H14.9004C14.1271 22.015 13.7149 20.9851 14.2258 20.3294Z",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnergy);
export default __webpack_public_path__ + "static/media/IconEnergy.c5c0d16756f504e4f09770c96113287d.svg";
export { ForwardRef as ReactComponent };